import React, { useEffect, useState } from 'react';
import { PostStyles } from './PostStyles';
import { useLocation, useNavigate } from 'react-router-dom';
import { IPost } from '../../enteties/IPost';
import Seo from '../../components/seo/Seo';
import { useAppSelector } from '../../state/hooks';
import { useIsFirstRender } from 'usehooks-ts';
import workWithResponse from '../../functions/workWithResponse';
import { AdminApi } from '../../api/adminApi';
import Loader from '../../components/loader/Loader';
import PostContentFromAdminPanel from '../../components/postContentFromAdminPanel/PostContentFromAdminPanel';
import Modal from '../../components/modal/Modal';
import ContactForm from '../../components/contactForm/ContactForm';

interface FormValues {
  email: string;
  accept: boolean;
}

const initialValues: FormValues = {
  email: '',
  accept: false,
};

function Post() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isFirst = useIsFirstRender();
  const { interfaceLanguage } = useAppSelector((state) => state.languages);

  const [postData, setPostData] = useState<IPost | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [registrationModalOpen, setRegistrationModalOpen] = useState(false);

  useEffect(() => {
    const splittedPathName: string[] = pathname.split('/');

    async function getInitialData() {
      // const languages = await workWithResponse(() => AdminApi.getLanguages()).then((res) => {
      //   if (res && !res.error && res.data) {
      //     return res.data;
      //   }
      // });

      workWithResponse(() => AdminApi.getPost(splittedPathName[splittedPathName.length - 1])).then(({ error, data: post }) => {
        if (!error && post) {
          // if (languages && interfaceLanguage !== languages.find((language) => language.id === post.languageID)?.code) {
          //   navigate(`/${interfaceLanguage}/blog`);
          // }

          setPostData(post);
        }
      });
    }

    getInitialData().then(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    if (!isFirst) {
      navigate(`/${interfaceLanguage}/announces`);
    }
  }, [interfaceLanguage]);

  return (
    <PostStyles className="colorWhite">
      <div>
        {!isLoading && postData ? (
          <>
            <Seo
              title={postData.metaTitle}
              description={postData.metaDescription}
              keywords={postData.keywords}
              lang={interfaceLanguage}
              noIndexPage={postData.noIndex}
              ogDescription={postData.ogDescription}
              ogTitle={postData.ogTitle}
            />

            {registrationModalOpen && (
              <Modal onClose={() => setRegistrationModalOpen(false)}>
                <ContactForm
                  withoutTitle
                  emailDescription={`Форма регістрації на сторінці анонсу: ${postData.name}`}
                  inModal
                />
              </Modal>
            )}

            {/* <div className="hashTags"> */}
            {/*  {['Blog', ...hashtags].map((tag) => <span key={tag}>{tag}</span>)} */}
            {/* </div> */}

            {postData.mainImage && <img src={postData.mainImage} alt="" />}

            <div className="container">
              <div className="content">
                <h1 className="textH2">{postData.contentTitle}</h1>
                <PostContentFromAdminPanel content={postData.content} />

                {pathname.split('/')[2] === 'announces' && (
                  <button className="button registrationButton" type="button" onClick={() => setRegistrationModalOpen(true)}>Реєстрація</button>
                )}
              </div>
            </div>
          </>
        ) : (
          <div className="container"><Loader /></div>
        )}
      </div>
    </PostStyles>
  );
}

export default Post;
